import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'OrderSearch',
})
export class OrderSearchPipe implements PipeTransform {
  constructor() {}

  transform(items: Array<any>, keyword: string, type: string): Array<any> {
    // 키워드가 있을 때
    if (keyword && items && type === 'order') {
      return items.filter(ele => {
        return ele.userId.name.indexOf(keyword) > -1 || ele.id.indexOf(keyword) > -1 || ele.shopId.shopName.indexOf(keyword) > -1;
      });
    }
    // 키워드가 있으면서 매출관리에서 검색할 경우
    if (keyword && items && type === 'sales') {
      return items.filter(ele => {
        return ele.shopId.shopName.indexOf(keyword) > -1 || ele.shopId.owner.indexOf(keyword) > -1;
      });
    }
    // 키워드가 없을 때
    if (!keyword && items) {
      return items;
    }
  }
}
